
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getPublicBrands } from '../lib/api';
import '../styles/BrandsPage.css';
import { imgSrc } from '../lib/env';
// ✅ IMPORT THESE (important)
import { Testimonials, StatsBar } from '../components/home/HomeComponents';

export default function BrandsPage() {
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    getPublicBrands()
      .then(setBrands)
      .catch(() => setBrands([]));
  }, []);

  // const BASE_URL = "http://localhost/CODIZN-full-project%20(2)/codizn/backend";

  const getImageUrl = (img) => {
    if (!img) return "https://dummyimage.com/600x600/cccccc/000000&text=No+Image";

    // ✅ if full URL (like Bing images)
    if (img.startsWith("http")) return img;

    // ✅ if already contains uploads path
    if (img.includes("/uploads")) return `http://localhost${img}`;

    // ✅ normal filename
    return `${BASE_URL}/uploads/${img}`;
  };

  return (
    <div className="brands-page">

      {/* ================= BRANDS GRID ================= */}
      <div className="brands-container">
        <h1 className="brands-title">Designers</h1>

        <div className="brands-grid">
          {brands.map((brand) => (
            <Link
              key={brand.id}
              to={`/shop?brand=${encodeURIComponent(brand.name)}`}
              className="brand-card"
            >
              <img
                src={imgSrc(brand.img) || "https://dummyimage.com/600x600/cccccc/000000&text=No+Image"}
                alt={brand.name}
                className="brand-img"
                onError={(e) => { e.target.src = "https://dummyimage.com/600x600/cccccc/000000&text=Error"; }}
              />

              <div className="brand-overlay" />

              <div className="brand-content">
                <div className="brand-name">{brand.name}</div>
                <div className="brand-shop">SHOP COLLECTION</div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* ================= ADD THESE SECTIONS ================= */}

      <Testimonials />
      <StatsBar />

    </div>
  );
}